<template>
  <div>
    <h1 slot="title" class="page-title">Edit Witness</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="form-horizontal">
              <selectlist
                :options="titles"
                v-model="form.title_id"
                label="Title"
                name="title"
                placeholder="Please Select"
              ></selectlist>

              <inputbox
                v-model="form.first_name"
                name="first_name"
                label="First Name"
              ></inputbox>

              <inputbox
                v-model="form.last_name"
                name="last_name"
                label="Last Name"
              ></inputbox>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
              ></inputbox>

              <inputbox
                v-model="form.email_address"
                name="email"
                label="Email Address"
                type="email"
              ></inputbox>

              <address-lookup
                :address="address"
                v-on:address="setAddress"
              ></address-lookup>

              <toggleswitch
                :labels="true"
                name="corroborate"
                label="Corroborate Clients Version of Events?"
                v-model="form.corroborate"
              ></toggleswitch>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-danger btn-raised float-left"
              name="delete"
              v-on:click.prevent="deleteWitness"
            >
              <i class="icon icon-delete"></i> Delete
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="cancel"
              v-on:click.prevent="cancel"
            >
              <i class="icon icon-cancel"></i> Back
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="updateWitness"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    witness: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      titles: [],
      client: null,
      witnessData: null,
      form: {},
      indicator: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      window.Ajax.get(
        '/incidents/' + this.incident + '/witnesses/' + this.witness
      )
        .then(response => {
          this.form = new window.Form({
            title_id: response.data.title_id,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            telephone: response.data.telephone,
            email_address: response.data.email_address,
            address_line_one: response.data.address_line_one,
            address_line_two: response.data.address_line_two,
            city: response.data.city,
            postcode: response.data.postcode,
            corroborate: response.data.corroborate
          });
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/titles')
        .then(response => {
          this.titles = response.data;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    updateWitness() {
      this.form
        .put('/incidents/' + this.incident + '/witnesses/' + this.witness)
        .then(response => {
          this.$emit('updated', response);
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    },

    deleteWitness() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' + this.incident + '/witnesses/' + this.witness
            )
              .then(response => {
                this.$emit('deleted', this.witness);
                this.indicator = false;
                this.$router.push(
                  `/first-notice-of-loss-plus/${this.incident}#parties`
                );
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the witness.'
                );
              });
          }
        })
        .catch(error => {});
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(error => {});
    }
  }
};
</script>
